import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getTractorDetails } from '../../../redux/loadDetails/loadDetailsActions'

const initDetails = {
  load: {},
  loads: [],
  loadIndex: 0
}
const mapDetails = {
  'all-loads': { key: 'loads', selector: 'allLoadsReducer' },
  'my-loads': { key: 'loads', selector: 'myLoadsReducer' },
  'my-offers': { key: 'offers', selector: 'myOffersReducer' },
  'offers-history': { key: 'offers', selector: 'historyOffersReducer' },
  'assigned-orders': { key: 'orders', selector: 'assignedOrdersReducer' },
  'ready-to-invoice': { key: 'orders', selector: 'readyOrdersReducer' }
}

const getModule = (module) => {
  const currentModule = mapDetails[module]
  return currentModule || {}
}

const useLoadDetailsHandler = (loadDetails, handleOpen) => {
  const { movementNumber, module } = loadDetails
  const { key, selector } = getModule(module)

  const dispatch = useDispatch()
  const REDUX = useSelector(state => state[selector])
  const data = REDUX && key ? REDUX[key] : []

  const [details, setDetails] = useState(initDetails)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (movementNumber && module) {
      setLoading(true)

      if (!data.length) handleOpen(false)

      const loads = data
      const load = data.find(item => item.movementNumber === movementNumber)
      const loadIndex = data.findIndex(item => item.movementNumber === movementNumber)

      if (module === 'assigned-orders' || module === 'ready-to-invoice') {
        dispatch(getTractorDetails(movementNumber))
      }

      setDetails(loadIndex === -1 ? initDetails : { loads, load, loadIndex })
      handleOpen(loadIndex !== -1)
    } else {
      setDetails(initDetails)
      handleOpen(false)
    }
  }, [dispatch, data, movementNumber, handleOpen, module])

  useEffect(() => {
    setLoading(false)
  }, [details])

  return {
    details,
    loading,
    setLoading
  }
}

export default useLoadDetailsHandler
